// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-RvU4","checkboxWrapper":"styles_checkboxWrapper__pUIMw"};